import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { StateController } from '../../helpers/state/state-management/state-controller';
import { UserInfo } from '../../types';
import accountInfo from '../../helpers/state/account-info';
import { getInitials } from '../../helpers/strings';

@customElement('multi-user-avatar')
export class MultiUserAvatar extends LitElement {
    @property({ type: String })
    size?: string;

    @property({ type: String })
    backgroundColor?: string = 'var(--theme-white-color)';

    @property({ type: String })
    textColor?: string = 'var(--theme-input-color)';

    @property({ type: Array })
    users: UserInfo[] = [];

    @state()
    maxAvatars = 6;

    private readonly bindAccountState = new StateController(this, accountInfo);

    connectedCallback() {
        super.connectedCallback();
        if (this.size === 'xl') {
            this.style.setProperty('--avatar-size', '10rem');
            this.style.setProperty('--avatar-font-size', '2rem');
        } else if (this.size === 'lg') {
            this.style.setProperty('--avatar-size', '4.5rem');
            this.style.setProperty('--avatar-font-size', '2rem');
        } else if (this.size === 'sm') {
            this.style.setProperty('--avatar-size', '1.5rem');
            this.style.setProperty('--avatar-font-size', '0.75rem');
        } else {
            this.style.setProperty('--avatar-size', '3rem');
            this.style.setProperty('--avatar-font-size', '1.5rem');
        }
    }

    render() {
        const usersCount = this.users.length ?? 0;
        const showPlusCircle = usersCount > this.maxAvatars;

        return html`
            <div style="display: flex; align-items: center;">
                ${this.users.slice(0, this.maxAvatars).map((user, index) => html`
                    <form-tooltip
                        tipwidth="180px"
                        leftPadding="30%"
                        style="font-size: 0.75rem; white-space: normal;"
                        message="${user.name ?? ''} ${user.email ?? ''}"
                    >
                        <account-avatar
                            .size=${this.size}
                            .textColor=${this.textColor}
                            .backgroundColor=${this.backgroundColor}
                            .imageUrl=${user.avatar}
                            style="margin-left: ${index === 0 ? '0' : '-0.35rem'};"
                        >
                            ${getInitials(user.name ?? '', user.email ?? '')}
                        </account-avatar>
                    </form-tooltip>
                `)}
                ${showPlusCircle ? html`
                    <div class="avatarOverlay" style="z-index: 0; margin-left: -0.35rem;">
                        <div class="plusCircle">
                            +${usersCount - this.maxAvatars}
                        </div>
                    </div>
                ` : ''}
            </div>
        `;
    }

    static get styles() {
        return css`
            .avatarOverlay {
                position: relative;
                z-index: 1;
            }

            .plusCircle {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                width: var(--avatar-size);
                height: var(--avatar-size);
                box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
                font-size: var(--avatar-font-size);
                cursor: pointer;
                border: 1px solid var(--theme-border-color);
                background-color: var(--theme-white-color);
            }
        `;
    }
}
